import { render, staticRenderFns } from "./RidersPreloader.vue?vue&type=template&id=3ec5b5d6&lang=pug&"
import script from "./RidersPreloader.vue?vue&type=script&lang=js&"
export * from "./RidersPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports